export default __webpack_public_path__ + "static/order-placed-db315682a5058ba62025d79106bce815.gif";